import { render } from "./dang-nhap.vue?vue&type=template&id=2a921090&scoped=true"
import script from "./dang-nhap.vue?vue&type=script&lang=js"
export * from "./dang-nhap.vue?vue&type=script&lang=js"

import "./dang-nhap.vue?vue&type=style&index=0&id=2a921090&scoped=true&lang=css"
import "./dang-nhap.vue?vue&type=style&index=1&id=2a921090&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a921090"]])

export default __exports__